import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import {
  useGetGeneralworkPermitByNumberQuery,
  useUpdateGeneralworkDynamicQuestionnaireByPermitNoMutation,
  useUpdateGeneralworkPermitMutation,
  useGetDynamicQuestionsByIdsQuery
} from "slices/safetyApp/safetyappSlice";

import EquipmentUsedQuestionnaire from "pages/SafetyApp/CommonWizardSteps/Wizards/EquipmentUsedQuestionnaire";

// Define types for the form values
interface Question {
  questionnaire_key: number;
  question: string;
  answer: string; 
  sort_id: number;
}

interface FormValues {
  questions: Question[];
}

interface EquipmentQuestionnaireIndexProps {
  previousStep: () => void;
  nextStep: () => void;
}

const EquipmentUsedQuestionnaireIndex: React.FC<EquipmentQuestionnaireIndexProps> = ({
  previousStep,
  nextStep,
}) => {
  // Get hwPermitNo from the URL parameters
  const { hwPermitNo } = useParams<{ hwPermitNo: string }>();
  const [equipmentIds, setEquipmentIds] = useState('');

  // Fetch questionnaire data
  const { data: questionnaireData, isLoading: questionLoading } =
  useGetDynamicQuestionsByIdsQuery(equipmentIds, {
    skip: !equipmentIds,
  });

  const [updatePermitQuestionnaireKey, { isLoading: patchisLoading }] =
  useUpdateGeneralworkDynamicQuestionnaireByPermitNoMutation();
  const [updatePermit] = useUpdateGeneralworkPermitMutation();


  console.log('questionnaireData---equip',questionnaireData);


  const {
    data: permitData,
    isLoading: isPermitLoading,
    refetch: refetchPermit,
  } = useGetGeneralworkPermitByNumberQuery(hwPermitNo);

  useEffect(() => {
    if (permitData?.equipment_used_m2m) {
      const ids = permitData.equipment_used_m2m.join(',');
      setEquipmentIds(ids);
    }
  }, [permitData]);

  const [initialQuestions, setInitialQuestions] = useState<Question[]>([]);

  // Initialize formik with the correct type for form values
  const formik = useFormik<FormValues>({
    initialValues: {
      questions: initialQuestions,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
          questions: equipmentIds ? 
            Yup.array().of(
              Yup.object({
                answer: Yup.string().required("Answer is required"),
              })
            ) : 
            Yup.array().optional(), // Make questions optional if no equipmentIds
        }),
    validateOnChange: false, // Disable validation on change
    validateOnBlur: false, // Disable validation on blur
    onSubmit: async (values) => {
      try {
        const payload = {
          questionnaire_updates: values.questions,
        };

        await updatePermitQuestionnaireKey({
          gw_permit_no: hwPermitNo,
          updatedQuestionnaireKeyData: payload,
        });

        // await updatePermit({
        //   hw_permit_no: hwPermitNo,
        //   updatedPermitData: {
        //     questionnaire_comments: values.comments,
        //   },
        // }).unwrap();

        nextStep();
      } catch (error) {
        console.error("Error updating questionnaire", error);
      }
    },
  });

  return (
    <EquipmentUsedQuestionnaire
      previousStep={previousStep}
      nextStep={nextStep}
      formik={formik}
      permitData={permitData}
      refetchPermit={refetchPermit}
      questionnaireData={questionnaireData}
      setInitialQuestions={setInitialQuestions}
      patchisLoading={patchisLoading}
      questionLoading={questionLoading}
      isPermitLoading={isPermitLoading}
    />
  );
};

export default EquipmentUsedQuestionnaireIndex;
